import { defineAbilitiesFor } from '@/config/ability'

export default {
  namespaced: true,
  state: {
    authenticated: false,
    user: {},
    providers: [],
    errors: {},
  },
  getters: {
    loggedIn: state => state.authenticated,
    subject(state) {
      return state.authenticated ? Vue.$auth.getPayload().subject : null
    },
    role(state) {
      return state.authenticated ? Vue.$auth.getPayload().role : 'guest'
    },
    fullName: state => {
      return state.user.id && state.user.firstName
        ? `${state.user.firstName} ${state.user.lastName}`
        : 'Anonymous'
    },
    email: state => (state.user.id ? state.user.email : 'Unknown'),
    user: state => state.user,
  },
  mutations: {
    authenticated: (state, authenticated) => (state.authenticated = authenticated),
    setUser: (state, user) => (state.user = user),
    setErrors: (state, errors = {}) => (state.errors = errors),
  },
  actions: {
    refresh({ commit, state }) {
      if (Vue.$auth.isAuthenticated()) {
        commit('authenticated', true)
        Vue.$http.get(Vue.$auth.getPayload().sub).then(response => {
          commit('setUser', response.data)

          // Authorization
          if (response.data && response.data.role) {
            Vue.$ability.update(defineAbilitiesFor(response.data))
          }

          // Context for Sentry
          Vue.$raven.setUserContext({
            id: state.user.id,
            email: state.user.email,
            username: `${state.user.firstName} ${state.user.lastName}`,
            role: Vue.$auth.getPayload().role,
          })
        })
      }
    },
    login({ commit, dispatch, state }, { auth }) {
      return Vue.$auth
        .login(auth)
        .then(
          // Login success
          response => {
            // Vue.$http.post('sessions') // TODO: Provide some session details
            if (response.status === 204) {
              // User doesn't exist
              commit(
                'snackbar',
                {
                  text: "You couldn't be logged in. Please check the login details again.",
                  type: 'error',
                },
                { root: true }
              )
            } else {
              dispatch('refresh')
            }
          },
          // Login failure
          errors => {
            commit(
              'snackbar',
              {
                text: "You couldn't be logged in. Please check the login details again.",
                type: 'error',
              },
              { root: true }
            )
          }
        )
        .catch(() => {
          commit(
            'snackbar',
            {
              text: "You couldn't be logged in. Please check the login details again.",
              type: 'error',
            },
            { root: true }
          )
        })
    },
    logOut({ getters, commit }) {
      Vue.$auth.logout().then(
        () => {
          // Update state to refresh getters
          commit('authenticated', Vue.$auth.isAuthenticated())
          commit('setUser', {})
          Vue.$ability.update([])
          Vue.$raven.setUserContext({})
        },
        () => {
          commit('authenticated', Vue.$auth.isAuthenticated())
          commit('setUser', {})
          Vue.$ability.update([])
          Vue.$raven.setUserContext({})
        }
      )
    },
  },
}
